import React from 'react';

import Checkbox from 'components/Checkbox';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { intlGet } from 'utils/intlGet';
import { ScrollableProps } from './models';
import styles from './styles.module.scss';

const Scrollable: React.FunctionComponent<ScrollableProps> = (props) => {
  const { scrollable, toggleScrollable, dataTestId = 'scrollable' } = props;

  return (
    <Dropdown className={styles.Scrollable} stopClickPropagation={true} dataTestId={`${dataTestId}-dropdown`}>
      <Checkbox
        onChange={toggleScrollable}
        checked={scrollable}
        label={intlGet('EditorToolbar.Scrollable', 'ScrollableLayout')}
        dataTestId={`${dataTestId}-checkbox`}
      />
      <div className={styles.description} data-testid={`${dataTestId}-description`}>
        {intlGet('EditorToolbar.Scrollable', 'Description')}
      </div>
    </Dropdown>
  );
};

export default Scrollable;
